<script setup lang="ts">
import { ref } from 'vue';
import 'primeicons/primeicons.css';
import Menu from 'primevue/menu';
import { ButtonType, CustomButton, UserAvatar } from '@/components';

const props = defineProps({
  user: {
    type: Object,
    required: true
  }
});

const emits = defineEmits(['resendInvite', 'removeUser']);

const getMenuItems = () => {
  const menuItems = [
    {
      label: 'Remove',
      icon: 'pi pi-trash',
      command: () => {
        emits('removeUser', props.user);
      }
    }
  ];

  if (props.user.status === 'Invited') {
    menuItems.push({
      label: 'Re-send invite',
      icon: 'pi pi-refresh',
      command: () => {
        emits('resendInvite', props.user);
      }
    });
  }

  return [
    {
      label: 'Options',
      items: menuItems
    }
  ];
};

const menu = ref();
const items = ref(getMenuItems());

const toggle = (event: PointerEvent) => {
  menu.value.toggle(event);
};

const icon = () => ({
  style: 'far',
  icon: 'ellipsis-vertical'
});
</script>

<template>
  <div class="root-user">
    <UserAvatar :avatarUrl="user.avatar"
      :userName="user.name"
      :user-email="user.email"
      :size="44"/>
    <CustomButton :icon="icon()"
      @onClick="toggle"
      :type="ButtonType.ICON_ONLY"/>
    <Menu ref="menu"
      id="overlay_menu"
      :model="items"
      :popup="true" />
  </div>
</template>

<style scoped lang="scss">
.root-user {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>
